import { ApiError } from '../transport/http'

/**
 * WHAT TO SHOW A PERSON WHEN A RESTART IS REFUSED.
 *
 * Owner, 2026-09-26, with a screenshot of his own card: it said `no_conversation_id`, in
 * red, under a button. That is the edge's machine-readable code for the refusal, and it
 * is not addressed to him.
 *
 * The edge already sends a sentence written for exactly this — `detail`, from
 * explainRestart — alongside the code. The card was reading the wrong field: ApiError's
 * message is built from `error`, which is the code.
 *
 * READ HERE RATHER THAN IN http.ts, deliberately. Preferring `detail` globally would
 * rewrite the message of every failing request in the app on the strength of one route's
 * need, and not every route means `detail` for a person to read.
 */
export function whyRestartFailed(err: unknown): string {
  const body = err instanceof ApiError ? (err.body as { detail?: unknown } | null) : null;
  const detail = typeof body?.detail === 'string' ? body.detail.trim() : ''
  if (detail) return detail
  return err instanceof Error && err.message ? err.message : 'the machine refused'
}
